import { render } from "./icon-document.vue?vue&type=template&id=45bcf447"
import script from "./icon-document.vue?vue&type=script&lang=js"
export * from "./icon-document.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__